export default "__VITE_ASSET__BuXP3s_i__"